import Book from './models/Book';
import Confucio from './models/Confucio';
import Cat from './models/Cat';
import Computer from './models/Computer';
import Ghost from './models/Ghost';
import Hamburger from './models/Hamburger';
import Polaroid from './models/Polaroid';
import Rocket from './models/Rocket';
import Ufo from './models/Ufo';


const modelsMap = new Map();

modelsMap.set('book', Book);
modelsMap.set('confucio', Confucio);
modelsMap.set('cat', Cat);
modelsMap.set('computer', Computer);
modelsMap.set('ghost', Ghost);
modelsMap.set('hamburger', Hamburger);
modelsMap.set('polaroid', Polaroid);
modelsMap.set('rocket', Rocket);
modelsMap.set('ufo', Ufo);


export default modelsMap;
